import script from "./Cart.vue?vue&type=script&setup=true&lang=js"
export * from "./Cart.vue?vue&type=script&setup=true&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=08241d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08241d62"]])

export default __exports__